<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_force_logout'">
                </div>
                <hr class="dialog-hr">
                <div class="confirm-body" v-html="$t('message.info_confirm_force_logout', { userName: userName })">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('logout')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
      return {
        userName: null
      };
    },
    created: function() {
        this.userName = this.confirmInfo.objectName;
    },
    props: ['confirmInfo']
}
</script scoped>

<style scoped>


</style>
